import React from "react";
import {
    FinancePartnerDetailsResponse,
    OpportunityInfoResponse,
} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {Table} from "antd";
import {areStringsEqual, renderPairItem, renderStatusIcon} from "./OpportunityValidationShared";

interface SalesPersonInfoProps {
    opportunity: OpportunityInfoResponse;
    financePartner: FinancePartnerDetailsResponse;
}

export const SalesPersonInfo: React.FC<SalesPersonInfoProps> = ({opportunity, financePartner}) => {

    const columns = [
        {
            title: 'SFDC',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[0]),
        },
        {
            title: financePartner.financePartnerType,
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[1]),
        },
        {
            title: 'SiteCapture',
            dataIndex: 'items',
            width: '30%',
            render: (value: any) => renderPairItem(value[2]),
        },
        {
            title: '',
            dataIndex: 'status',
            width: '10%',
            align: 'center',
        },
    ];

    const items = [
        {
            items: [
                {
                    name: 'Trinity Salesperson',
                    value: opportunity.sfdc.sfdcTrinitySalesPerson,
                },
                {
                    name: 'Salesperson (Owner)',
                    value: financePartner.financePartnerSalesPersonOwner,
                },
                {
                    name: 'Assignee',
                    value: opportunity.siteCapture.scAssignee,
                },
            ],
            status: renderStatusIcon(areStringsEqual(
                opportunity.sfdc.sfdcTrinitySalesPerson ?? '',
                financePartner.financePartnerSalesPersonOwner ?? '',
                opportunity.siteCapture.scAssignee ?? '')),
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};